import * as React from 'react';

import { IFAQCategory } from '../../types/promoInfo';
import { useModalWindowWithParams } from '../../utils/useModalWindowWithParams';
import { FAQModalContainer, IFAQModalContainerExt } from '../FAQModalContainer';
import { FAQSection } from '../../components/FAQSection';
import { trackDealRegistrationClick } from './tracking';
import { useGetContent } from './utils/useGetContent';
import { useApplicationContext } from '../../utils/applicationContext';
import { ERuntimeSettings } from '../../types/runtimeSettings';

/**
 * Секция "Часто задаваемые вопросы".
 */
export const FAQSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { config } = useApplicationContext();

  const [modalProps, setModalOpen] = useModalWindowWithParams<IFAQModalContainerExt>();
  const isSbrEnabled = config.get<boolean>('e2e-deal-sale.Sbr.Enabled') || false;
  const isAbsolutBankEnabled = config.getStrict<boolean>(ERuntimeSettings.OnlineMeetingAbsolutBankEnabled);

  const content = useGetContent({ isAbsolutBankEnabled, isSbrEnabled });

  const onCategoryClick = (modalContent: IFAQCategory) => {
    setModalOpen(modalContent);
    trackDealRegistrationClick(modalContent.category);
  };

  return (
    <>
      <FAQSection content={content} onCategoryClick={onCategoryClick} />
      <FAQModalContainer {...modalProps} />
    </>
  );
};
